import ZuhanItem from './_item';


export default class Zuhan{
    
    constructor(){
        this.zuhanList = [];
    }


    setup(){
        this._create();
    }
    

    _create(){
        
        [...document.querySelectorAll('.js-gl-zuhan')].forEach($zuhan=>{
            const item = new ZuhanItem($zuhan);
            this.zuhanList.push(item);
        });
    }
}